import script from "./ViewAdminMemoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAdminMemoPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewAdminMemoPage.vue?vue&type=style&index=0&id=7ac58e22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ac58e22"]])

export default __exports__